<template>
    <div class="page-container">
        <div class="input-grp" @click="selectCustom">
            <div class="input-name">收货人</div>
            <!-- <input type="text" v-model="addressStr" disabled class="input-ref" placeholder="请选择客户" /> -->
            <div class="input-ref" v-if="addressStr != ''">{{addressStr}}</div>
            <div class="input-ref" v-else style="color:#999;">请选择客户</div>
        </div>
        <div class="input-grp">
            <div class="input-name" style="margin-top:15px;">提货商品</div>
            <div class="goods-block" v-for="(item,index) in goodsList" :key="index">
                <div class="goods-info-block">
                    <img :src="item.picUrl" class="goods-pic">
                    <div class="goods-detail">
                        <div class="goods-name">{{`${item.name} ${item.degree}度 ${item.capacity}`}}</div>
                        <div class="goods-sku">
                            <span>{{item.skuValue == 'xiang' ? '整箱(6瓶)' : '单瓶'}}</span>
                            <span style="color:#3088F5;">x{{item.number}}({{item.skuValue == 'xiang' ? '箱' : '瓶'}})</span>
                        </div>
                        <div class="caigou-price">采购价：¥{{item.price}}/瓶</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 提货单信息 -->
        <div class="order-block">
            <div class="block-title">提货单信息</div>
            <div class="block-content">
                <div class="content-item">
                    <van-field
                        v-model="fare"
                        label="运费"
                        placeholder=""
                        disabled
                        input-align="right"
                    />
                </div>
                <div class="content-item">
                    <van-field
                        v-model="message"
                        rows="1"
                        autosize
                        label="订单备注"
                        type="textarea"
                        maxlength="50"
                        placeholder="给商家留言，选填"
                        show-word-limit
                    />
                </div>
            </div>
        </div>
        <!-- <div class="input-grp">
            <div class="input-name">是否开票</div>
            <input type="text" class="input-ref" placeholder="请选择是否开票" />
        </div> -->
        <div class="input-grp">
            <div class="input-name">本次销售金额 <span>(非必填，仅为方便您记录销售额)</span></div>
            <input type="number" v-model="saleAmount" class="input-ref" placeholder="请输入销售金额" />
        </div>
        <div class="bottom-notice" v-show="showNotice">请选择收货人</div>
        <div class="btn-confirm" @click="confirm">确认提货</div>

        <!-- 输入密码弹层 -->
        <van-overlay :show="showPasswordLayer">
            <div class="wrapper">
                <div class="layer-content-block" :class="{'wrapper-to-top':showKeyboard}">
                    <div class="content-title">请输入交易密码 <van-icon name="cross" class="btn-close" size="22" color="#d2d2d2" @click.stop="showPasswordLayer = false" /></div>
                    <div class="content-bottom">
                        <div class="pay-detial">需支付运费</div>
                        <div class="price">
                            ¥ <span>{{fare == '包邮' ? 0 : fare}}</span>
                        </div>
                        <div class="account-info"><span>付款账户</span><span>御粮账户</span></div>
                        <!-- 密码输入框 -->
                        <van-password-input
                        :value="password"
                        :focused="showKeyboard"
                        @focus="showKeyboard = true"
                        />
                        <div class="err-notice" v-show="passwordErrorMsg">{{passwordErrorMsg}}</div>
                        <div class="layer-btn-confirm" @click="confirmPasswd">确认提货</div>
                    </div>
                </div>
            </div>
        </van-overlay>
        <!-- 数字键盘 -->
        <van-number-keyboard
        v-model="password"
        :show="showKeyboard"
        @blur="showKeyboard = false"
        />
    </div>
</template>

<script>
import { Field,Toast,Overlay,Icon,PasswordInput,NumberKeyboard } from 'vant'
import md5 from 'js-md5'
import $http from '@/lib/request'
import config from '@/config'


export default {
    data(){
        return {
            fare:0,
            message:'',
            goodsList:[],//商品列表
            addressInfo:{},//当前地址信息
            addressStr:'',//用来显示的已选择的地址信息
            saleAmount:'',//本次销售额
            showPasswordLayer:false,
            password:'',
            showKeyboard:false,
            passwordErrorMsg:'',//密码错误提示信息
            oid:'',//提交申请返回的订单id
            amount:0,
            showNotice:false,
        }
    },
    components:{
        [Field.name]:Field,
        [Toast.name]:Toast,
        [Overlay.name]:Overlay,
        [Icon.name]:Icon,
        [PasswordInput.name]:PasswordInput,
        [NumberKeyboard.name]:NumberKeyboard
    },
    watch:{
        showPasswordLayer(val,oldVal){
            this.password='';
        }
    },
    methods:{
        selectCustom(){
            this.$router.push({
                name:'address-list'
            });
        },
        confirm(){
            if(!this.addressInfo.id){
                this.showNotice=true;
                return;
            }
            let tmpData=[],
                tmpAmount=0,
                list=this.goodsList;
            for(let i=0;i<list.length;i++){
                tmpData.push({
                    goodsId:list[i].goodsId,
                    num:list[i].number,
                    unit:list[i].skuValue == 'xiang' ? '箱' : '瓶'
                });
                //计算总价
                if(list[i].skuValue == 'xiang'){
                    tmpAmount+=list[i].price * list[i].number * 6;
                }else{
                    tmpAmount+=list[i].price * list[i].number;
                }
            }
            this.amount=tmpAmount;

            $http({
                method:'post',
                data:{
                    body:tmpData,
                    addressId:this.addressInfo.id,
                    saleAmount:this.saleAmount,
                    freight:this.fare == '包邮' ? 0 : this.fare,
                    message:this.message
                },
                url:config.api.confirmPickup
            }).then(res=>{
                if(res.errno == 0){
                    this.oid = res.data;
                    // this.showPasswordLayer = true;
                    this.$router.push({
                        name:'common-yzm',
                        params:{
                            orderId:this.oid,
                            action:'tihuo',
                            freight:this.fare == '包邮' ? 0 : this.fare
                        }
                    });
                }else{
                    Toast(res.errmsg);
                }
            })
        },
        confirmPasswd(){
            $http({
                method:'post',
                data:{
                    jyPassword:md5(this.password)
                },
                url:config.api.validatePassword
            }).then(res=>{
                if(res.errno == 0){
                    this.$router.push({
                        name:'common-yzm',
                        params:{
                            orderId:this.oid,
                            jyPassword:this.password,
                            action:'tihuo'
                        }
                    });
                }else{
                    this.passwordErrorMsg=res.errmsg
                }
            })
        },
    },
    activated(){
        this.showNotice=false;
        this.goodsList=this.$store.state.currentPickupGoodsInfo;

        let addinfo=this.$store.state.currentAddressInfo;
        if(addinfo){
            this.addressInfo=addinfo
            this.addressStr=`${addinfo.name},${addinfo.mobile},${addinfo.province}${addinfo.city}${addinfo.county}${addinfo.address}`
        }

        //获取运费信息
        let list=this.goodsList;
        let tmparr=[];
        for(let i=0;i<list.length;i++){
            tmparr.push({
                num:list[i].number,
                unit:list[i].skuValue == "xiang" ? '箱' : '瓶'
            });
        }
        if(this.addressStr){
            $http({
                method:'post',
                data:{
                    addressId:this.addressInfo.id,
                    body:tmparr,
                },
                url:config.api.getFareInfo
            }).then(res=>{
                if(res.errno == 0){
                    this.fare=res.data == 0 ? '包邮' : res.data;
                }else{
                    Toast(res.errmsg)
                }
            });
        }
    },
    deactivated(){
        this.showPasswordLayer=false;
        this.password='';
        this.showKeyboard=false;
        this.passwordErrorMsg='';//密码错误提示信息
        this.addressStr='';
        this.addressInfo={};
    }
}
</script>

<style lang="scss" scoped>
@mixin flex-beteween{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
::v-deep .van-cell{
    padding:0;
    margin-top:10px;
}
::v-deep .van-password-input{
    margin:0;
}
::v-deep .van-field--disabled .van-field__label{
    color:#646566;
}
::v-deep .van-field__control:disabled{
    color:#323233;
    -webkit-text-fill-color:#323233;
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.wrapper-to-top{
    transform: translateY(-40%);
}
.layer-content-block {
    background-color: #fff;
    width:300px;
    border-radius: 8px;
    .content-title{
        height:50px;
        line-height: 50px;
        text-align: center;
        position: relative;
        color:#333;
        font-size: 18px;
        .btn-close{
            position: absolute;
            right:15px;
            top:50%;
            transform: translateY(-50%);
        }
    }
    .content-bottom{
        padding:20px 28px;
        .pay-detial{
            font-size: 13px;
            color:#333;
            line-height: 18px;
            text-align: center;
            margin-bottom: 5px;
        }
        .price{
            text-align: center;
            color:#333;
            font-size: 26px;
            font-weight: 500;
            font-family: PingFangSC-Medium, PingFang SC;
            margin-bottom: 20px;
            &>span{
                font-size: 36px;
            }
        }
        .account-info{
            border-top:1px solid #f0f0f0;
            padding-top: 15px;
            line-height: 18px;
            margin-bottom: 25px;
            @include flex-beteween();
            &>span{
                font-size: 13px;
                color:#333;
                &:last-child{
                    font-weight: 500;
                }
            }
        }
        .err-notice{
            margin-top: 10px;
            color:#E43D3D;
            font-size: 13px;
            line-height: 18px;
        }
        .layer-btn-confirm{
            height:40px;
            line-height: 40px;
            text-align: center;
            border-radius: 26px;
            background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
            color:#fff;
            font-size: 16px;
            margin-top: 25px;
        }
    }
}
.page-container{
    min-height:100vh;
    box-sizing: border-box;
    background:#f5f5f5;
    padding:10px;
    .order-block{
        background:#fff;
        padding:15px;
        margin-bottom: 15px;
        border-radius: 4px;
        .block-title{
            font-size: 14px;
            color:#333;
            margin-bottom: 15px;
        }
    }
    .input-grp{
        font-size: 16px;
        color:#000;
        line-height: 22px;
        .input-name{
            margin-bottom: 10px;
            &>span{
                color:#999;
                font-size: 12px;
            }
        }
        .input-ref{
            display: block;
            box-sizing: border-box;
            padding:0 15px;
            background:#fff;
            width:100%;
            height:40px;
            line-height: 40px;
            font-size: 14px;
            border:none;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            border-radius: 4px;
            color:#000;
        }
        .goods-block{
            background:#fff;
            border-radius: 4px;
            padding:15px;
            box-sizing: border-box;
            margin-bottom: 10px;
            .goods-info-block{
                display: flex;
                justify-content: flex-start;
                .goods-pic{
                    width:80px;
                    height:80px;
                    margin-right: 10px;
                    border-radius: 4px;
                }
                .goods-detail{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width:calc(100% - 70px);
                    .goods-name{
                        overflow: hidden;
                        text-overflow:ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        color:#000;
                        line-height: 20px;
                        font-size: 14px;
                    }
                    .goods-sku{
                        @include flex-beteween();
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                    }
                    .caigou-price{
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                    }
                }
            }
        }
    }
    .bottom-notice{
        color:#E43D3D;
        line-height: 18px;
        text-align: center;
        margin-top: 20px;
        font-size: 14px;
    }
    .btn-confirm{
        width: 180px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
        font-size: 14px;
        color:#fff;
        margin:0 auto;
        margin-top: 40px;
        @media screen and (max-width:750px){
            border-radius: 26px;
        }
    }
}
</style>